import { Configuration, LogLevel, PublicClientApplication, EventType, BrowserCacheLocation, AuthError } from "@azure/msal-browser";
import { logger } from './logger';

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.NEXT_PUBLIC_GULFSTREAM_PLATFORM_AUTH_ID!,
    authority: process.env.NEXT_PUBLIC_GULFSTREAM_PLATFORM_AUTH_AUTHORITY!,
    redirectUri: `${process.env.NEXT_PUBLIC_GULFSTREAM_PLATFORM_AUTH_REDIRECT_URL}/redirect`,
    navigateToLoginRequestUrl: true,
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: BrowserCacheLocation.LocalStorage,
    storeAuthStateInCookie: true,
    secureCookies: true,
  },
  system: {
    windowHashTimeout: 60000,
    iframeHashTimeout: 60000,
    loadFrameTimeout: 60000,
    tokenRenewalOffsetSeconds: 1800,
    allowRedirectInIframe: true,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        // Only log in development environment
        if (process.env.NODE_ENV !== 'development') {
          // In production, only log errors
          if (level === LogLevel.Error) {
            console.error(message);
          }
          return;
        }
        
        switch (level) {
          case LogLevel.Error:
            logger.error(message);
            break;
          case LogLevel.Warning:
            logger.warn(message);
            break;
          case LogLevel.Info:
            logger.info(message);
            break;
          case LogLevel.Verbose:
            logger.debug(message);
            break;
        }
      },
      piiLoggingEnabled: false,
      // Only use Info level in development, use Error in production
      logLevel: process.env.NODE_ENV === 'development' ? LogLevel.Info : LogLevel.Error,
    },
  },
};

// Create and export the MSAL instance
export const msalInstance = new PublicClientApplication(msalConfig);

// Add event listeners for debugging and monitoring
msalInstance.addEventCallback((event) => {
  // Token acquisition events
  if (event.eventType === EventType.ACQUIRE_TOKEN_START) {
    logger.debug("Token acquisition started");
  } else if (event.eventType === EventType.ACQUIRE_TOKEN_SUCCESS) {
    logger.debug("Token acquisition completed successfully");
  } else if (event.eventType === EventType.ACQUIRE_TOKEN_FAILURE) {
    logger.error("Token acquisition failed", event.error);
    // Handle specific error cases
    if (event.error instanceof AuthError && event.error.errorCode === 'monitor_window_timeout') {
      logger.warn('Silent token acquisition timed out, will try interactive flow');
    }
  }
  
  // Login/logout events
  if (event.eventType === EventType.LOGIN_START) {
    logger.debug("Login started");
  } else if (event.eventType === EventType.LOGIN_SUCCESS) {
    logger.debug("Login completed successfully");
  } else if (event.eventType === EventType.LOGIN_FAILURE) {
    logger.error("Login failed", event.error);
  } else if (event.eventType === EventType.LOGOUT_START) {
    logger.debug("Logout started");
  } else if (event.eventType === EventType.LOGOUT_SUCCESS) {
    logger.debug("Logout completed successfully");
  } else if (event.eventType === EventType.LOGOUT_FAILURE) {
    logger.error("Logout failed", event.error);
  }
});

export const loginRequest = {
  scopes: [
    "User.Read",
    "User.ReadBasic.All",
    "profile",
    "openid",
    "offline_access",
    "GroupMember.Read.All"
  ],
  extraQueryParameters: {
    domain_hint: process.env.NEXT_PUBLIC_GULFSTREAM_PLATFORM_AUTH_DOMAIN || ''
  }
};

export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};